import axios from 'axios'

export default {
    addOfflineServerFace({commit}, params){
        return axios.post('/api/shengfuyou/offline_server/user/add', params)
    },
    getEmployeeNo({commit}, params){
        return axios.post('/api/shengfuyou/offline_server/user/info/get', params)
    }
}


// WEBPACK FOOTER //
// ./src/vuex/actions/h5.js